export default __webpack_public_path__ + "static/media/muro1.8281f5bf.png";